var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "plotWrapper",
      staticStyle: {
        width: "100%",
        position: "relative",
        "overflow-x": "hidden",
        display: "flex",
        "flex-direction": "column",
        gap: "10px",
      },
      attrs: { id: _vm.wrapperId },
    },
    [
      _c(
        "svg",
        {
          staticClass: "legend-svg",
          attrs: { width: "230", height: "54", viewBox: "0 0 230 54" },
        },
        [
          _c(
            "defs",
            [
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: _vm.legendGradientId,
                    x1: "0%",
                    y1: "0%",
                    x2: "100%",
                    y2: "0%",
                  },
                },
                _vm._l(_vm.legendGradientStops, function (stop) {
                  return _c("stop", {
                    key: stop.offset,
                    attrs: { offset: stop.offset, "stop-color": stop.color },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "text",
            {
              attrs: {
                x: "0",
                y: "12",
                "font-family": "Arial",
                "font-size": "11",
                "font-weight": "600",
                fill: "#333",
              },
            },
            [_vm._v(_vm._s(_vm.legendTitle))]
          ),
          _c("rect", {
            attrs: {
              x: "0",
              y: "18",
              width: "100",
              height: "10",
              rx: "5",
              fill: `url(#${_vm.legendGradientId})`,
            },
          }),
          _c(
            "text",
            {
              attrs: {
                x: "0",
                y: "44",
                "font-family": "Arial",
                "font-size": "11",
                fill: "#333",
              },
            },
            [_vm._v(_vm._s(_vm.legendMinLabel))]
          ),
          _c(
            "text",
            {
              attrs: {
                x: "100",
                y: "44",
                "text-anchor": "end",
                "font-family": "Arial",
                "font-size": "11",
                fill: "#333",
              },
            },
            [_vm._v(_vm._s(_vm.legendMaxLabel))]
          ),
          _c(
            "text",
            {
              attrs: {
                x: "122",
                y: "12",
                "font-family": "Arial",
                "font-size": "11",
                "font-weight": "600",
                fill: "#333",
              },
            },
            [_vm._v("% Cells Expressing")]
          ),
          _vm._l(_vm.legendCircles, function (circle) {
            return _c(
              "g",
              {
                key: circle.cx,
                attrs: { transform: `translate(${circle.cx}, 23)` },
              },
              [
                _c("circle", {
                  attrs: { r: "8", fill: "white", stroke: "#ccc" },
                }),
                _c("circle", { attrs: { r: circle.r, fill: "#ccc" } }),
              ]
            )
          }),
          _c(
            "text",
            {
              attrs: {
                x: "122",
                y: "44",
                "font-family": "Arial",
                "font-size": "11",
                fill: "#333",
              },
            },
            [_vm._v("0")]
          ),
          _c(
            "text",
            {
              attrs: {
                x: "227",
                y: "44",
                "text-anchor": "end",
                "font-family": "Arial",
                "font-size": "11",
                fill: "#333",
              },
            },
            [_vm._v("100")]
          ),
        ],
        2
      ),
      _c("div", { ref: "plot" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }